import { ISettings, ISettingsItem } from '@dataTypes/settings.type'

export enum AccountsSection {
  Personal = 'personal',
  Professional = 'professional',
  Work = 'work',
  Password = 'password',
}

export const ACCOUNTS_NAV_LINKS: ISettingsItem[] = [
  {
    id: 'account-personal-info',
    name: 'Personal info',
    description: 'Personal information',
  },
  {
    id: 'account-professional-info',
    name: 'Professional info',
    description: 'Professional information',
  },
  {
    id: 'account-work-schedule',
    name: 'Work schedule',
    description: 'Work schedule',
  },
  {
    id: 'account-password-security',
    name: 'Password & security',
    description: 'Password and security',
  },
]

export const ACCOUNTS_NAV_ITEMS: ISettings[] = [
  {
    id: 'account-profile',
    name: 'Profile',
    description: 'Your account profile',
    icon: 'ti ti-user',
    items: ACCOUNTS_NAV_LINKS,
  },
]
